<template>
  <v-dialog v-model="dialog" max-width="400">
    <div class="scartati">
      <v-card>
        <v-card-title class="cyan headline">
          <span class="white--text">Calciatori scartati</span>
          <v-spacer></v-spacer>
          <v-btn depressed class="white--text" light icon @click="dismiss">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- body -->
        <div class="px-4 pt-4">
          I calciatori scartati non compaiono tra gli svincolati
          (particolarmente utile se si usa l'estrazione casuale e non si vuole
          che vengano estratti alcuni calciatori minori)
        </div>
        <div class="d-flex align-center px-4 py-2">
          <v-icon small class="text--text mr-2">info</v-icon>
          <div>
            I calciatori messi all'asta ma non assegnati a nessuno terminano
            automaticamente tra gli scartati.
          </div>
        </div>

        <!-- Select ruoli -->
        <div class="d-flex justify-center">
          <select-ruoli-classic
            v-if="classic"
            v-model="selectedRuoloClassic"
          ></select-ruoli-classic>

          <select-ruoli-mantra
            v-else
            v-model="selectedRuoliMantra"
          ></select-ruoli-mantra>
        </div>

        <!-- lista scartati -->
        <div v-if="scartati && _.size(scartati) > 0">
          <v-list class="scartati-list pa-0">
            <calciatore
              v-for="scartato in scartati"
              :key="scartato.id"
              :id="scartato.id"
              showButtonsScartaRiabilita
              borderAsRuolo
              textScuro
              showQuotazione
              :scartato="true"
            ></calciatore>
          </v-list>
        </div>
        <div v-else class="lista-vuota py-4">
          Nessun calciatore scartato in questo ruolo.
        </div>

        <!-- actions -->
        <v-card-actions class="justify-center">
          <v-btn outlined rounded class="" @click="manageAggiungiScartati"
            ><v-icon small left>fa-plus-circle</v-icon>Aggiungi</v-btn
          >
          <v-btn
            depressed
            rounded
            @click="rimuoviScartati()"
            class="cyan white--text px-4"
            v-if="_.size(scartati) > 1"
          >
            Riabilita tutti
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";
import mixins from "../../js/mixins";
import Vuex from "vuex";
import Calciatore from "../common/Calciatore";
import SelectRuoliClassic from "@/components/common/SelectRuoliClassic";
import SelectRuoliMantra from "@/components/common/SelectRuoliMantra";

export default {
  name: "dialog-scartati",
  mixins: [mixins],
  components: { Calciatore, SelectRuoliClassic, SelectRuoliMantra },
  data() {
    return {
      dialog: false,
      selectedRuoloClassic: Constants.RUOLO.P, // tanto sono sicuro che il Portiere ci sta sempre
      selectedRuoliMantra: [],
    };
  },
  mounted() {
    console.log("--> DialogScartati ready.");
    db.on("manageScartati", this.show);
  },
  destroyed() {
    console.log("<-- DialogScartati destroyed.");
    db.off("manageScartati", this.show);
  },
  methods: {
    show() {
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
    rimuoviScartati() {
      if (!this.admin) {
        db.emit("swalAdmin");
        return;
      }
      db.rimuoviScartati().then(this.astaLogRemoveScartati());
    },
    manageAggiungiScartati() {
      db.emit("manageAggiungiScartati");
    },
  },
  computed: {
    scartati() {
      const scartati = this.scartati_ids.map((key) => this.calciatori[key]);

      const startatiFiltered = this.classic
        ? scartati.filter((c) => c.ID_Ruolo == this.selectedRuoloClassic)
        : scartati.filter(
            (c) =>
              this.selectedRuoliMantra.length == 0 ||
              _.intersection(c.mantra_ids, this.selectedRuoliMantra).length > 0
          );

      return startatiFiltered.sort((a, b) => {
        if (a.ID_Ruolo !== b.ID_Ruolo)
          return parseInt(a.ID_Ruolo) - parseInt(b.ID_Ruolo); // asc
        if (a.quotazione !== b.quotazione) return b.quotazione - a.quotazione; // desc
        return a.calciatore
          .toUpperCase()
          .localeCompare(b.calciatore.toUpperCase()); // Alphabetical order
      });
    },
    ...Vuex.mapGetters(["scartati_ids", "is_mobile"]),
  },
};
</script>
<style lang="scss" scoped>
.lista-vuota {
  width: 100%;
  text-align: center;
}
.scartati-list {
  max-height: 400px;
  overflow: auto;
}
</style>
